const config = {
    'theme': 'keydirect.scss',
    'logo': 'keydirect.svg',
    'endpoint': "https://api.key-direct.at/v1"
};


export default config;